<template>
    <div class="product__image col-lg-6 col-sm-12 col-xs-12"
         :class="{
             'with-thumbnails' : enoughThumbnails,
             'zoomed-by-keyboard': zoomedByKeyboard
         }"
    >
        <template v-if="currentImage">
            <zoom-on-hover :img-normal="currentImage.url" :img-zoom="currentImage.big" :scale="1.5" />
            <a href="#" class="zoom-button" aria-label="Zoom product image" @click.prevent="zoomedByKeyboard = !zoomedByKeyboard">
                <span v-if="zoomedByKeyboard" class="fas fa-search-minus"></span>
                <span v-else class="fas fa-search-plus"></span>
            </a>
        </template>
        <template v-if="enoughThumbnails">
            <div class="thumbnails text-center">
                <a v-for="(image, index) in images"
                   href="javascript:;"
                   @click.prevent="selectedImageIndex = index"
                   :class="(index === selectedImageIndex) ? 'active' : null">
                    <img :src="image.thumbnail" :alt="image.original_name" class="img-thumbnail">
                </a>
                <a v-for="(video, index) in videos"
                   class="video-link"
                   href="javascript:"
                   data-init="videoPopup"
                   :data-url="video.url"
                   :class="{'fill-black': !getVideoThumbnail(video)}"
                   >
                    <img :src="getVideoThumbnail(video)" :alt="video.original_name" class="img-thumbnail">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                        <title>play</title>
                        <path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13zM12 9l12 7-12 7z"></path>
                    </svg>
                </a>
                <a v-for="(video, index) in externalVideos"
                   class="video-link"
                   href="javascript:"
                   data-init="videoPopup"
                   :data-url="video.source"
                   :class="{'fill-black': !getVideoThumbnail(video)}"
                >
                    <img :src="getVideoThumbnail(video)" :alt="video.original_name" class="img-thumbnail">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                        <title>play</title>
                        <path d="M16 0c-8.837 0-16 7.163-16 16s7.163 16 16 16 16-7.163 16-16-7.163-16-16-16zM16 29c-7.18 0-13-5.82-13-13s5.82-13 13-13 13 5.82 13 13-5.82 13-13 13zM12 9l12 7-12 7z"></path>
                    </svg>
                </a>
            </div>
        </template>
    </div>
</template>

<script>
import '../../util/videoPopup'

export default {
    name: 'productImage',
    props: {
        images: {
            type: Array,
            default: () => [],
        },
        videos: {
            type: Array,
            default: () => [],
        },
        externalVideos: {
            type: Array,
            default: () => []
        },
    },
    data: () => ({
        currentIndex: 0,
        zoomedByKeyboard: false,
    }),
    computed: {
        selectedImageIndex: {
            get() { return this.currentIndex; },
            set(newIndex) {
                this.currentIndex = newIndex;
                this.$emit('update-current-image-index', newIndex);
            }
        },
        currentImage: function () {
            if (!this.images.length) {
                return false;
            }

            return this.images[this.selectedImageIndex] || this.images[0];
        },
        enoughThumbnails() {
            const {images, videos, externalVideos} = this

            return images.length > 1 || videos.length > 0 || externalVideos.length > 0
        }
    },
    mounted() {
        new VideoPopup({})
    },
    methods: {
        getVideoThumbnail(videoObj) {
            return videoObj?.thumbnail?.data?.thumbnail || ''
        }
    }
}
</script>

<style scoped lang="scss">
.video-link {
    position: relative;

    svg {
        position: absolute;
        width: 15px;
        height: 15px;
        left: calc(50% - 7.5px);
        top: calc(50% - 7.5px);
        fill: white;
    }
}
.fill-black {
    svg {
        fill: black;
    }
}
</style>
